<template>
  <div class="document-container">
    <div class="doc-name">
      <p class="name">开发注意事项</p>
      <p class="update-time">{{currentParams.updateTime}}</p>
    </div>
    <div class="request-module-box">
      <div class="module-name">
        <span>注意事项</span>
      </div>
      <div class="module-text">
        <span>
          1、在您通过提交订单接口进行订单提交时，您需要首先确认需要下单的物料ID和物料数量。另外，您需要确定您的收货地址的省份编码。在
          <a
            target="_blank"
            href="https://market.aliyun.com/products/57126001/cmapi011154.html?spm=5176.10695662.1996646101.searchclickresult.9bf51458LITKfM#sku=yuncode515400003"
          >这里</a> 您可以查询到对应的省份编码（ProvinceID 前6位）。
        </span>
      </div>
      <div class="module-text">
        <span>
          2、在您提交省份编码后，油柑网开放平台会返回支持的快递。请注意，当您选择到店自提或者送货上门的配送方式的时候，您不需要指定快递。油柑网当前的到店自提服务仅支持送往华强北门店。油柑网当前的送货上门服务仅支持送往华强北门店200米范围内。具体的送货时间以及发货时间，请在
          <a
            target="_blank"
            href="https://www.youganw.com/serve/deliver_goods"
          >这里</a>查询。
        </span>
      </div>
      <div class="module-text">
        <span>3、在您获得支持的快递之后，您需要调用计价接口来计算订单的价格。之后您可以调用下单接口进行创建订单的操作。详细的流程如下图。</span>
      </div>
      <div class="module-img">
        <img src="../../../../assets/images/order-step.png" />
      </div>
    </div>
  </div>
</template>
<script>
import Tables from "@/components/Tables";
import publicData from "@/api/public/index";
import { createOrderApi } from "@/api/order/index";
export default {
  components: {
    Tables
  },
  data() {
    return {
      publicParams: publicData,
      currentParams: createOrderApi
    };
  }
};
</script>
<style lang="less" scoped>
.document-container {
  padding: 0 40px;
  text-align: left;
  .doc-name {
    border-bottom: 1px solid #dedede;
    > .name {
      font-size: 24px;
      text-align: left;
      color: #333;
    }
    > .update-time {
      margin-top: 10px;
      margin-bottom: 30px;
      font-size: 12px;
      color: #666666;
    }
  }
  .request-module-box {
    .module-name {
      height: 60px;
      font-size: 16px;
      line-height: 60px;
      color: #333;
    }
    .table-box {
    }
    .module-text {
      font-size: 14px;
      line-height: 40px;
      text-align: justify;
      a {
        color: #4fbfff;
        text-decoration: underline;
      }
    }
    .module-img {
      margin-top: 10px;
      img {
        width: 100%;
        display: block;
      }
    }
    .code-example {
      background-color: #e8e8e8;
    }
  }
}
</style>